    <div class="section left">
      <button *ngIf="sidebarTag" class="sidebar-toggle" (click)="toggleSidebar()">
        <nb-icon icon="menu-2"></nb-icon>
      </button>
      <div class="logo">
        <a routerLink="/">Santea</a>
        <a routerLink="/" class="slogan">
          HUMAN HEALTH
        </a>
      </div>
    </div>
    <div class="section middle">
      <nb-menu style="text-transform: none; margin-right: 1rem;" [items]="mainMenu"></nb-menu>
      <!-- <ngd-search *ngIf="showSearch"></ngd-search> -->
     <!--  <nb-select class="version-select" 
                 *ngIf="(showVersionSelect$ | async)"
                 [selected]="currentVersion$ | async"
                 (selectedChange)="redirectToVersion($event)">
        <nb-option *ngFor="let version of supportedVersions$ | async" [value]="version">
          {{ version.name }}
        </nb-option>
      </nb-select> -->
   

    </div>
    <div class="section right">

      <!-- pinned doctor: the principal an assistant is currently working for -->
      <select-principal *ngIf="state.user" class="pinnedPrincipal"></select-principal>
      <!-- logged in user -->
       <a *ngIf="state.user"
       class="headerUserLink"
       [routerLink]="['/f', profileSlug, 'me', 'info']"
       [attr.title]="'header.openProfile' | translate">
             <nb-user *ngIf="state.user" class="headerUser"
                
             [name]="state.user.firstName + ' ' + state.user.lastName"
               [picture]="state.user.profilePicture?.formats?.thumbnail?.url">
      </nb-user>
       </a>
      <div class="buttonWrapper"> 
      <button *ngIf="!state.user && !isOnLoginPage()" (click)="navigateToLoginAndRedirectAfter(router)" nbButton hero status="success" id="loginButton">{{'hhPlatform.home.hero.login' | translate }}</button>
      <button *ngIf="!state.user" (click)="redirectToSignup()" nbButton status="basic" id="signupButton">{{'hhPlatform.home.areYouDoctor' | translate }}</button>
      <button *ngIf="state.user" (click)="logout()" nbButton status="basic" id="logoutButton" [style.color]="isOnIndexPage() ? '#3366ff' : ''">{{'hhPlatform.home.logout' | translate }}</button>
    </div>
      <!--  <span> test</span> -->
    </div>
    <!-- country flag icons -->
    <div class="section right">
      <img class="languageIcon" src="assets/svgs/flags/sh.svg" alt="English" (click)="useLanguage('en')" />
      <img class="languageIcon" src="assets/svgs/flags/de.svg" alt="Deutsch" (click)="useLanguage('de')" />
      <img class="languageIcon" src="assets/svgs/flags/fr.svg" alt="Français" (click)="useLanguage('fr')" />
    </div>
  